
import React from "react";
import { useAiContext } from "./AiContext";

export function AiFloatingButton() {
  const { isAiOpen, setAiOpen } = useAiContext();

  return (
    <button
      onClick={() => setAiOpen(!isAiOpen)}
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #6366f1, #a855f7)",
        color: "#fff",
        border: "none",
        boxShadow: "0 4px 14px rgba(0,0,0,0.4)",
        zIndex: 2100,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 24,
        transition: "transform 0.2s",
      }}
      title={isAiOpen ? "關閉 AI 法律助手" : "開啟 AI 法律助手"}
      onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
      onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
    >
      ✨
    </button>
  );
}
